import React, { Component } from 'react';
import { connect } from 'react-redux';
import SpinLoading from './common/SpinLoading';
import * as ReactIntl from 'react-intl';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import history from './historyManager';
import * as locale from './locale';
import { LOGIN_PAGE, HOME_PAGE, JOIN } from './routes';
import './App.scss';

const localeData: any = {
	'pt-BR': locale.ptBR,
	'en-US': locale.enUS,
	'es-ES': locale.esES,
};

//
const Dashboard = React.lazy(() => import('./common/Dashboard'));
const Auth = React.lazy(() => import('./features/Auth'));
const Join = React.lazy(() => import('./features/Join'));

interface AppProps {
	language?: string;
}

interface AppState {}

class AppComponent extends Component<AppProps, AppState> {

	render() {

		const { language } = this.props;

		return (
			<React.Suspense fallback={<SpinLoading />}>
				<ReactIntl.IntlProvider
					locale={language || 'pt-BR'}
					messages={localeData[language || 'pt-BR']}
				>
					<div className="ApplicationContainer">
						<Router history={history}>
							<Switch>
								<Route path={`${LOGIN_PAGE}/:token?/:lang?`} component={Auth} />
								<Route path={`${JOIN}/:id?`} component={Join} />
								<Route path={"/"} component={Dashboard} />
							</Switch>
						</Router>
					</div>
				</ReactIntl.IntlProvider>
			</React.Suspense>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		language: state.global.language,
	};
};

export default connect(mapStateToProps)(AppComponent);

